import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/logo/login-mohuan.jpg'
import _imports_1 from '@/assets/images/logo/login-meiyujiaoxue.jpg'


_pushScopeId("data-v-4a38fc7c")
const _hoisted_1 = {
  key: 0,
  class: "login-top-logo"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  key: 1,
  class: "login-logo-img",
  src: _imports_0
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  class: "login-logo-img",
  src: _imports_1
}, null, -1)
const _hoisted_5 = { class: "app-info" }
const _hoisted_6 = { class: "app-mac" }
const _hoisted_7 = { class: "app-company" }
const _hoisted_8 = { key: 0 }
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoginCard = _resolveComponent("LoginCard")!
  const _component_Setting = _resolveComponent("Setting")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_SettingDialog = _resolveComponent("SettingDialog")!
  const _component_software_control_bar = _resolveComponent("software-control-bar")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["login", _ctx.classLoginBackground])
  }, [
    (!_ctx.isML)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_ctx.schoolLogo)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                class: "login-logo-img school-logo",
                src: _ctx.schoolLogo
              }, null, 8, _hoisted_2))
            : (_openBlock(), _createElementBlock("img", _hoisted_3)),
          _hoisted_4
        ]))
      : _createCommentVNode("", true),
    (_ctx.canRenderLoginCard)
      ? (_openBlock(), _createBlock(_component_LoginCard, {
          key: 1,
          lastLoginType: _ctx.lastLoginType,
          changeSchoolLogo: _ctx.getLocalSchoolLogo
        }, null, 8, ["lastLoginType", "changeSchoolLogo"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_el_icon, {
          class: "sp-set",
          onClick: _ctx.btnOpenDialog
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Setting)
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createElementVNode("span", {
          id: "copyMac",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.copyMac && _ctx.copyMac(...args)))
        }, _toDisplayString(_ctx.macInfo), 1)
      ]),
      _createElementVNode("div", _hoisted_7, [
        (!_ctx.isML)
          ? (_openBlock(), _createElementBlock("span", _hoisted_8, "福建星网视易信息系统有限公司"))
          : _createCommentVNode("", true),
        _createElementVNode("span", null, " v" + _toDisplayString(_ctx.version), 1)
      ])
    ]),
    (_ctx.dvIcePointState)
      ? (_openBlock(), _createBlock(_component_SettingDialog, {
          key: 2,
          onBtnOpenDialog: _ctx.btnOpenDialog
        }, null, 8, ["onBtnOpenDialog"]))
      : _createCommentVNode("", true),
    _createVNode(_component_software_control_bar, { style: {"bottom":"90px"} })
  ], 2))
}